import Vue from 'vue'
import {bearingToAzimuth} from '@turf/helpers'


//transforme le bearing -180 à 180  en cap 0 - 360
Vue.filter('formatBearing', function(value:number) {
  if (value || value === 0) {     
    return bearingToAzimuth(value).toFixed(2) + "°"
  }
})